import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { Dashboard } from "../pages/protected/dashboard.jsx";
import { Login } from "../pages/NotProtectedOnly/Login.jsx";
import { Route } from "react-router-dom";
import { About } from "../pages/About";
import { Contact } from "../pages/Contact";
import { ProtectedRoute } from "../layouts/ProtectedRoutes";
import { RoleProtectedRoute } from "../layouts/RoleProtectedRoute";
import { GlobalErrorElement } from "../components/GlobalErrorElement.jsx";
import { ErrorBoundary } from "react-error-boundary";
import { NotProtectedOnlyRoutes } from "../layouts/NotProtectedOnlyRoutes.jsx";
import { Layout } from "../layouts/Layout.jsx";
import { Signup } from "@/pages/NotProtectedOnly/Signup.jsx";
import { DashboardLayout } from "@/pages/protected/DashboardLayout.jsx";
import { Roles } from "@/pages/protected/Roles.jsx";
import UserForm from "@/pages/protected/UserForm.jsx";
import CreateRole from "@/pages/protected/CreateRole.jsx";
import EditRole from "@/pages/protected/EditRole.jsx";
import Permissions from "@/pages/protected/Permissions.jsx";
import CreatePermission from "@/pages/protected/CreatePermission.jsx";
import EditPermission from "@/pages/protected/EditPermission.jsx";
import Users from "@/pages/protected/Users.jsx";
import { Head_of_department } from "@/pages/protected/HOD/head_of_department.jsx";
import Advisors from "@/pages/protected/Advisors/Advisors.jsx";
import { Form } from "@/pages/Users/Form.jsx";
import { Intro_video } from "@/pages/Users/Intro_video.jsx";
import { Submissions } from "@/pages/protected/Submissions/Submissions.jsx";
import UserSubmissionView from "@/pages/protected/Submissions/UserSubmissionView.jsx";
import { InitialQuestionnaire } from "@/components/InitialQuestionnaire";
import { CompletionMessage } from "@/components/CompletionMessage";
import {SignupLegaltoUser } from "@/pages/NotProtectedOnly/SignupLegaltoUser.jsx";
import { OtpVerification } from "@/pages/NotProtectedOnly/OtpVerification.jsx";
import { ForgotPassword } from "@/pages/ForgetPassword/ForgetPassword.jsx";
import { ResetPassword } from "@/pages/ForgetPassword/ResetPassword.jsx";
import Reports from "@/pages/protected/Reports.jsx";
import { Unauthorized } from "@/pages/Unauthorized.jsx";
import DeceasedUserView from "@/pages/DeceasedUserView.jsx";
import { SimpleProtectedLayout } from "@/layouts/SimpleProtectedLayout.jsx";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      errorElement={
        <GlobalErrorElement
          error={new Error("Page Not Found")}
          resetErrorBoundary={() => {}}
        />
      }
    >
      {/* Error boundry and Layout is defined here */}
      <Route
        element={
          <ErrorBoundary FallbackComponent={GlobalErrorElement}>
            <Layout />
          </ErrorBoundary>
        }
      >
        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          {/* Routes that need simple layout */}
          <Route element={<SimpleProtectedLayout />}>
            <Route path="/video" element={<Intro_video />} />
            <Route path="/initial-questionnaire" element={<InitialQuestionnaire />} />
            <Route path="/questionnaire-complete" element={<CompletionMessage />} />
          </Route>

          <Route path="/register" element={<Signup />} />
          <Route path="/" element={<DashboardLayout />} >
            <Route path="/" element={<Dashboard />} />
            <Route path="Users" element={<Users />} />
            <Route path="Roles" element={<Roles />} />
            <Route path="head_of_department" element={<Head_of_department />} />
            <Route path="advisors" element={<Advisors />} />
            <Route path="/roles/create" element={<CreateRole />} />
            <Route path="/roles/edit/:id" element={<EditRole />} />
            <Route path="/form" element={<Form />} />
            <Route path="submissions" element={<Submissions />} />
            <Route path="submissions/:userId/form/:submissionId" element={<UserSubmissionView />} />
            
            <Route path="users/create" element={<UserForm />} />
            <Route path="users/edit/:id" element={<UserForm />} />

            <Route path="/permissions" element={<Permissions />} />
            <Route path="/permissions/create" element={<CreatePermission />} />
            <Route path="/permissions/edit/:id" element={<EditPermission />} />
            <Route path="Signup" element={<Signup />} />
            <Route path="users/new" element={<SignupLegaltoUser />} />
            
            {/* Role-specific protected routes */}
            <Route element={<RoleProtectedRoute allowedRoles={["admin", "reporting"]} />}>
              <Route path="reports" element={<Reports />} />
            </Route>
          </Route>
        </Route>

        {/* Public Routes - Authenticated users will be redirected to home */}
        <Route element={<NotProtectedOnlyRoutes />}>
          <Route path="login" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
        </Route>

        {/* Public Routes - Accessible to all */}
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="user/register" element={<Signup />} />
        <Route path="/otp-verification" element={<OtpVerification />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/user-data/:hash_id" element={<DeceasedUserView />} />
      </Route>
    </Route>
  )
);
